import request from './request'

export const getCategoryList = (params) => {
  return request({
    url: '/admin/categories',
    method: 'get',
    params
  })
}

export const getCategoryDetail = (id) => {
  return request({
    url: `/admin/categories/${id}`,
    method: 'get'
  })
}

export const createCategory = (data) => {
  return request({
    url: '/admin/categories',
    method: 'post',
    data
  })
}

export const updateCategory = (id, data) => {
  return request({
    url: `/admin/categories/${id}`,
    method: 'put',
    data
  })
}

export const deleteCategory = (id) => {
  return request({
    url: `/admin/categories/${id}`,
    method: 'delete'
  })
}